import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useStaticQuery, graphql } from 'gatsby'
import Img, { FluidObject } from 'gatsby-image'

import { Container } from 'components/Container'
import { backgroundColors, colors } from 'styles/colors'
import { displayWidth } from 'styles/width'
import { mobileAfterBorder } from 'styles/mobileAfterBorder'
import { Title } from 'components/TitleComponent'
import { getDataByLanguage } from 'utils/getDataByLanguage'

import { Button } from 'components/Button'
import { JumpingArrow } from 'components/JumpingArrow'
import { indent } from 'styles/indent'
import { sendEvent } from 'tracking'
import { imagesDataProp } from 'types/interfaces'
import { getImageByImageName } from 'utils/getImageByImageName'
import { sendForm } from 'components/form/api'

const Visualization3dWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: ${backgroundColors.project};
    position: relative;
    border-bottom: 1px solid ${colors.dark};
    ${mobileAfterBorder}
`

const SubTitle = styled.h3`
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.4px;
    color: ${colors.dark};
    margin: 20px ${indent.heroColumnDesktop};
    @media (min-width: ${displayWidth.tablet}) {
        margin: 0 ${indent.heroColumnTablet} 48px;
        text-align: left;
    }
    @media (min-width: ${displayWidth.desktop}) {
        margin: 0 ${indent.heroColumnDesktop} 48px;
    }
`

const HeroColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 32px;
    align-items: center;
    border-bottom: 1px solid ${colors.dark};
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: none;
        padding: 0 0 32px;
        border-right: 1px solid ${colors.dark};
    }
`
const ImgStyled = styled(Img)<{ fluid: FluidObject }>`
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    align-self: center;
    @media (min-width: ${displayWidth.tablet}) {
        max-width: calc((100vw - 160px) * 0.6666);
        padding: 0;
    }
    @media (min-width: ${displayWidth.desktop}) {
        width: 793px;
    }
`
const ImgWrapper = styled.div`
    padding: 0 16px;
    @media (min-width: ${displayWidth.tablet}) {
        padding: 0;
    }
`

const ButtonStyled = styled(Button)`
    width: 264px;
    margin: 0 auto 50px;
    z-index: 3;
    a {
        text-decoration: none;
        color: #fff;
        font-size: 18px;
    }
    @media (max-width: 330px) {
        width: 250px;
    }
    @media (min-width: ${displayWidth.tablet}) {
        width: 220px;
    }
    @media (min-width: ${displayWidth.desktop}) {
        width: 264px;
    }
`

export const Project3D = ({ imagesData }: { imagesData: imagesDataProp }) => {
    const { i18n, t } = useTranslation()
    const data = useStaticQuery(graphql`
        query {
            allProject3DYaml {
                edges {
                    node {
                        title
                        subTitle
                        buttonText
                        parent {
                            ... on File {
                                name
                            }
                        }
                    }
                }
            }
        }
    `)
    const project3DYaml = getDataByLanguage(
        data.allProject3DYaml,
        i18n.language
    )
    const image = getImageByImageName(imagesData, 'picture3D.webp')

    const { title, subTitle } = project3DYaml

    return (
        <Visualization3dWrapper>
            <Container columns={'1fr'} tabletColumns={'1fr 2fr'}>
                <HeroColumn>
                    <Title>{title}</Title>
                    <SubTitle>{subTitle}</SubTitle>

                    <ButtonStyled
                        onClick={() => {
                            sendForm(`Скачали 3д`, {})
                            sendEvent('Click', {
                                eventCategory: 'DownloadExemple3d',
                                placement: 'Promo',
                            })
                        }}
                    >
                        <a
                            href="https://clearline.com.ua/exampleProject3d.pdf"
                            download
                        >
                            {t('downloadProject')} (1.8{t('mb')})
                        </a>
                    </ButtonStyled>

                    <JumpingArrow />
                </HeroColumn>
                <ImgWrapper>
                    <ImgStyled
                        fluid={image.fluid}
                        loading="eager"
                        alt="picture3D image"
                        title="picture3D image"
                    />
                </ImgWrapper>
            </Container>
        </Visualization3dWrapper>
    )
}
